module.exports = __webpack_public_path__ + "img/produit_1.08190159.png";